"use client";

import Script from "next/script";
import cx from "classnames";

const Icon = ({
  provider = "fa",
  icon = "fa-solid fa-thumbs-up",
  size = "",
  className = null,
  onClick = () => {},
  ...props
}) => {
  return (
    <div className="contents" onClick={onClick}>
      <Script src="https://kit.fontawesome.com/99f7b6cd00.js" crossOrigin="anonymous"></Script>
      <i className={cx(icon, className, size)} {...props}></i>
    </div>
  );
};

export default Icon;
